import { GET_CODES, UPDATE_CODES, CREATE_CODES, CHANGE_CODES, GET_CODES_CORE } from './../constants';
import { handleActions } from "redux-actions"

export const codes  = handleActions(
  {
    [ GET_CODES ]: (state, action) => action.payload,
    [ GET_CODES_CORE ]: (state, action) => {
      let dataReturn = {}
      if (action.payload.name ==='Timeout') {
        dataReturn = state
      } else
      if (action.payload.error ) {
        dataReturn = state
      } else {
        dataReturn = action.payload.data.MovimientosCuenta
      }
      return dataReturn
    },
    [ UPDATE_CODES ]: (state, action) => state,
    [ CREATE_CODES ] : (state, action) => state,
    [ CHANGE_CODES ] : (state, action) => {
      const result  = action.payload
      const { data } = result
      const codeArray  = state
      const initialValue = []
      const newCode = codeArray.reduce((acc, code) => {
          if (code.id === data.id) {
            // console.log(code.id +  ' con ' + data.id)
              return [...acc, data]
          } else {
              return [...acc, code]
          }
      }, initialValue)
      return newCode
  },
    
  }, []
)